import React, { Suspense } from 'react'
import ReactDOM from "react-dom";
import App from "./App";
import "./index.css"
import { DarkModeContextProvider } from "./context/darkModeContext";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
ReactDOM.render(
  <React.StrictMode>
      <Suspense fallback={<div>Loading...</div>}>
    <I18nextProvider i18n={i18n}>
      <DarkModeContextProvider>
        <App />
      </DarkModeContextProvider>
    </I18nextProvider>
      
      </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);
